import {getFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

export const PostUpgradePlanCartToCart = async (
  payload: IPlanCartToCartPayload,
) => {
  await request.post(
    `/api/v2/subscription/store-plans-card-to-card`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
    {headers: {'content-type': 'multipart/form-data'}},
  );
};
